import s from './Chat.module.scss';
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useWebSocket } from '../../../../redux/socket/WebSocket';
import { ReactComponent as NotRegisteredIcon } from '../../../../assets/icons/unregistered_user.svg';
import {ReactComponent as RegisteredIcon} from "../../../../assets/icons/registered_user.svg";
import {ReactComponent as ReadIcon} from "../../../../assets/icons/read.svg";
import {ReactComponent as UnreadIcon} from "../../../../assets/icons/unread.svg";
import { DateFormat } from 'utils/enums/common.enum';
import { format } from 'date-fns';
import { useGetLocale } from 'utils/hooks/useGetLocale';
import {ReactComponent as SmileIcon} from '../../../../assets/icons/smile.svg'
import {ReactComponent as AddIcon} from '../../../../assets/icons/add.svg'
import {ReactComponent as SendIcon} from '../../../../assets/icons/send.svg'
import { useTranslation } from 'react-i18next';
import {ReactComponent as DownloadIcon} from "../../../../assets/icons/download.svg"
import { useStatusContext } from 'components/StatusProvider';
import { EmojiModal } from 'components/EmojiModal/EmojiModal';
import { ReactComponent as Copy } from "../../.././../assets/icons/copy.svg"
import { ReactComponent as Success } from "../../.././../assets/icons/success_copy.svg"

const API = process.env.REACT_APP_API_ADDRESS

export const Chat = ({support}: any) => {
    
    // ### State
    const [message, setMessage] = useState<string>('')
    const [file, setFile] = useState<any>()
    const [emoji, setEmoji] = useState(false)
    const [isCopy, setIsCopy] = useState<boolean>(false)
    const {socket} = useWebSocket()
    const scrollRef = useRef<HTMLDivElement>(null)
    const locale = useGetLocale()
    const {t} = useTranslation()
    const { openStatus } = useStatusContext()

    const userData = localStorage.getItem('userData')
        ? JSON.parse(localStorage.getItem('userData')!)
        : null;

    // ### Effects

    useEffect(()=>{
        const interval = setInterval(() => {
            socket?.emit("get_online_users")
        }, 3000)

        return () => {
            clearInterval(interval)
        }
    },[]);


    useEffect(()=>{
        if(file){
            scroll(scrollRef)
        }
    },[file]);

    useLayoutEffect(()=>{
        setTimeout(()=>{
            scroll(scrollRef)
        },0)
    },[support?.messages]);

    // ### Functions

    function handleCopy(){
        setIsCopy(true)
        setTimeout(()=>{
            setIsCopy(false)
        },2000)
    }

    function scroll(scrollRef: any){
        if(scrollRef.current){
            scrollRef.current.scrollTo({
                top: scrollRef.current.scrollHeight
            })
        }
    }

    async function Send({message, supportId}: any){
        if(!message.length) return
        socket?.emit("support_answer", {message: message, supportId, author: userData?.id})
        setMessage('') 
    }

    async function SendFile(){
        if(file){
            const reader = new FileReader();
            reader.onload = () => {
                socket?.emit("support_answer", {
                    message: "", 
                    supportId: support.supportId, 
                    author: userData?.id,
                    file: reader.result,
                    file_name: file.name
                })
                setFile(undefined)
            };
            reader.readAsArrayBuffer(file);
        }
    }

    function changeFile(file: any){
        const size = Math.ceil(file.size / 1000 / 1000)
        if(size > 2){
            openStatus("error", "Maximum size 2MB")
            return
        }
        setFile(file)
    }


    function downloadBlobUrl(link: string, fileName: string) {
        const a = document.createElement('a');
        a.href = `${API}api${link}`;
        a.download = fileName;
        a.click();
    }
    
    // ### Views
    const messagesView = useMemo(() => support?.messages?.map((message: any, index: number) => {
        const me = message.user == userData?.id
        
        if(message.file) {
            return(
                <div key={index} className={s.message_wrapper}>
                    <p className={s.author} style={{background: me ? "#EC7C40" : support?.color}}>{message.name[0]}</p>
                    <div className={`${s.message} ${me ? s.my_message : ''}`}>
                        <p>{message?.file_name}</p>
                        <img className={s.message_image} src={`${API}api${message.file}`} alt="image" />
                        <div className={s.absolute_wrapper}>
                            <span className={s.date}>{format(new Date(message.date), "d MMMM yyyy HH:mm", { locale: locale })}</span>
                            {
                                me ?
                                message?.status ? <ReadIcon/> : <UnreadIcon/>
                                :null
                            }
                        </div>
                        <div className={s.download} onClick={() => downloadBlobUrl(message.file, message.file_name)}><DownloadIcon/></div>
                    </div>
                </div>
            )
        }else{
            return(
                <div key={index} className={s.message_wrapper}>
                    <p className={s.author} style={{background: me ? "#EC7C40" : support?.color}}>{message.name[0]}</p>
                    <div className={`${s.message} ${me ? s.my_message : ''}`}>
                        <p dangerouslySetInnerHTML={{__html: message.message}}></p>
                        <div className={s.absolute_wrapper}>
                            <span className={s.date}>{format(new Date(message.date), "d MMMM yyyy HH:mm", { locale: locale })}</span>
                            {
                                me ?
                                message?.status ? <ReadIcon/> : <UnreadIcon/>
                                :null
                            }
                        </div>
                    </div>
                </div>
            )
        }
    }), [support?.messages]) 

    return(
        <div className={s.wrapper}>
            
            <div className={s.header}>
                <div className={s.registered}>
                    {support?.registered ? 
                        <div className={s.registered_icon}><RegisteredIcon/></div>
                        :
                        <div className={s.not_registered_icon}>{<NotRegisteredIcon/>}</div>}
                    <span className={s.value}>{support?.registered ? t('support.registered') : t('support.not_registered')}</span>
                </div>
                <div className={s.email}>
                    <span className={s.title}>Email: </span>
                    <span className={s.value}>{support?.email}</span>
                    <div className={s.copy_button} onClick={(e)=>{
                        e.stopPropagation();
                        navigator.clipboard.writeText(support?.email)
                        .then(() => handleCopy())
                        .catch(err => alert("Ошибка копирования:"));
                    }
                    }>{isCopy ? <Success/> : <Copy />}</div>
                </div>
                <div className={s.date}>
                    <span className={s.title}>{t('support.start_date')}:</span>
                    <span className={s.value}>{support?.date && format(new Date(support?.date), DateFormat.LONG)}</span>
                </div>
            </div>
            <div className={s.chat_wrapper} ref={scrollRef}>
                {messagesView}
                {
                    file ? 
                    <div className={`${s.message_wrapper} ${s.message_file_wrapper}`}>
                        <p className={s.author}>{userData?.info?.name?.[0]}</p>
                        <div className={`${s.message} ${s.my_message}`}>
                            <p>{file?.name}</p>
                            <div className={s.send} onClick={SendFile}><SendIcon/></div>
                        </div>
                    </div> : null
                }
            </div>
            <div className={s.area}>
                <textarea
                    rows={1}
                    value={message}
                    onChange={(e) => {
                        setMessage(e.target.value)
                        e.target.style.height = 'auto';
                        e.target.style.height = e.target.scrollHeight + 'px';
                        scroll(scrollRef)
                    }}
                >
                </textarea>
                <div className={s.tools}>
                    <div className={s.smile}>
                        <div onClick={() => setEmoji(true)}><SmileIcon/></div>
                        <EmojiModal 
                            show={emoji} 
                            setValue={(value: any) => setMessage((prev:string) => prev + value)}
                            close={()=>setEmoji(false)}
                        />
                    </div>
                    
                    <div className={s.tool} style={{border: "1px res solid"}}>
                        <input
                            type="file"
                            className={s.input}
                            onChange={(event) => changeFile(event.target.files?.[0])}
                            accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.odt,.csv"
                        />
                        <AddIcon/>
                    </div>
                    <div className={s.send} onClick={()=>Send({message, supportId: support.supportId})}><SendIcon/></div>
                </div>
            </div>
        </div>
    )
}